/**
 * Post-Checkout thank-you page.
 *
 * Stripe Checkout redirects here on success_url. The query string carries
 * `stripe_success=<checkout_session_id>` (which we deliberately do NOT trust
 * for any state mutation — the customer.subscription.created webhook is the
 * source of truth). This page exists purely to give the buyer a confident
 * "you're all set" moment after they paid, and to remind them where the next
 * steps live (in the welcome email, not on this page).
 *
 * Why we don't show next-step links inline:
 *   - The Connect-Extension setup link requires a one-time setup token signed
 *     by the API; that token is generated server-side and embedded in the
 *     welcome email. We don't have it client-side here.
 *   - The buyer at this point likely has no Clerk session (they checked out
 *     as a Stripe guest), so any dashboard link would dead-end at sign-in.
 *
 * So we point them to their inbox and let the welcome email do the work.
 */

import { Link, useSearchParams } from 'react-router-dom';

export function Thanks() {
  const [search] = useSearchParams();
  const sessionId = search.get('stripe_success');

  return (
    <div className="page-centered">
      <div className="card card-narrow">
        <div style={{ fontSize: 48, lineHeight: 1, marginBottom: 8 }}>✓</div>
        <h1>Payment received</h1>
        <p className="muted" style={{ marginBottom: 8 }}>
          Thanks for subscribing to GroupPulse.
        </p>
        <p style={{ marginTop: 0 }}>
          We just sent a welcome email to the address you used at checkout —
          it has your dashboard link, the Chrome extension download, your
          one-time extension setup link, and a calendar link to book your
          onboarding call.
        </p>
        <p className="muted" style={{ fontSize: 14, marginBottom: 0 }}>
          Subject line:{' '}
          <strong>Welcome to GroupPulse — let&apos;s get you set up</strong>
        </p>

        <div
          className="actions"
          style={{ marginTop: 28, flexDirection: 'column', alignItems: 'stretch' }}
        >
          <a
            className="btn btn-primary"
            href="https://mail.google.com/mail/u/0/#search/from%3Anotifications%40notifications.grouppulsehq.com"
            target="_blank"
            rel="noreferrer"
          >
            Open Gmail
          </a>
          <Link to="/sign-in" className="btn btn-secondary">
            Already have an account? Sign in
          </Link>
        </div>

        {sessionId && (
          <p
            className="muted"
            style={{
              marginTop: 24,
              fontSize: 11,
              fontFamily:
                'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace',
            }}
          >
            Reference: {sessionId}
          </p>
        )}
      </div>
    </div>
  );
}
